/**
 * PORTED — RO-3-00c / #44470.
 * Origin: `excellent/app/_modes/market-title-toolbar.tsx`.
 *
 * Changes:
 *   `runningRun` from `@/market/db` → `useApi(modes.marketChrome, {})` (READ)
 *   `../market/_client`             → `../market/market-actions` (RO-3-00 port)
 */

import { SectionActions } from "@excellent/ui";
import { useApi } from "@excellent/ui/api";
import { modes } from "@excellent/ui/api/contracts/modes";
import { RunAnalysisButton } from "../market/market-actions";

export function MarketTitleToolbar(_ctx: {
  searchParams: Record<string, string | string[] | undefined> | undefined;
  workspaceId: number;
  projectSlug?: string;
}) {
  const { data } = useApi(modes.marketChrome, {});
  const running = data?.running ?? false;
  return <SectionActions primary={<RunAnalysisButton running={running} />} />;
}
